import { Box } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
const TableCont = ({ name, subText, handler, bgColor, icon }) => {
  return (
    <TableCont.Wrapper hasIcon={icon}>
      <Box className='container' bgcolor={bgColor} onClick={handler}>
        {icon && <img src={icon} alt='icons' />}
        <Box className='text'>
          <Box
            display='flex'
            justifyContent='space-between'
            alignItems='center'
            m={icon ? '0' : '0 0 5px'}
          >
            <div className='heading'>{name}</div>
            {icon && <ChevronRightIcon />}
          </Box>

          <div className='sub'>{subText}</div>
        </Box>
      </Box>
    </TableCont.Wrapper>
  );
};

export default TableCont;
TableCont.Wrapper = styled(Box)`
  .container {
    display: flex;
    margin: 0.5rem 0 0.5rem 0;
    padding: 10px;
    cursor: pointer;
    background: #ffffff;
    border: 0.854961px solid #e1e1e1;
    box-shadow: 0px 5px 18px rgba(40, 41, 61, 0.07);
    border-radius: 10px;
    .text {
      margin-left: ${({ hasIcon }) => (hasIcon ? '1rem' : '0')};
      width: 100%;
      .heading {
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 15px;
        color: #545454;
      }
      .sub {
        font-weight: normal;
        font-size: 12px;
        line-height: 137.86%;
        color: #878787;
        margin-top: 0;
      }
    }
  }
`;
